import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Tumi/Arrow.png'
import _imports_1 from '@/assets/Tumi/Cloud.png'


const _withScopeId = n => (_pushScopeId("data-v-747c6075"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Add files ", -1))
const _hoisted_3 = { class: "TumiBlockImages row align-items-center" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "TumiArrow",
  src: _imports_0
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "col-10" }
const _hoisted_12 = { class: "col-1 text-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "TumiCloud",
  src: _imports_1
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "col-1 text-end" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "col-10" }
const _hoisted_19 = { class: "col-2 text-end" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "image" }, {
      default: _withCtx(() => [
        (!_ctx.numberAdmitted || (_ctx.newPictures.length + _ctx.newFiles.length + _ctx.oldPictures.length + _ctx.oldFiles.length) < _ctx.numberAdmitted)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["dropzone mt-2 rounded", {hightlight: _ctx.hightlight}]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFileSelection && _ctx.openFileSelection(...args))),
              onDragover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
              onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
              onDrop: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
            }, [
              _hoisted_2,
              _createElementVNode("input", {
                ref: "fileInput",
                class: "file-input",
                type: "file",
                multiple: "",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
              }, null, 544)
            ], 34))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_TransitionGroup, { name: "image" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oldPictures, (oldP) => {
              return (_openBlock(), _createElementBlock("div", {
                key: oldP,
                class: "col-3 TumiPicture mt-3"
              }, [
                _createElementVNode("img", {
                  src: _ctx.GetPicture(oldP),
                  class: "img-fluid",
                  alt: oldP
                }, null, 8, _hoisted_4),
                _createElementVNode("div", {
                  class: "TumiClose TumiDownload",
                  onClick: ($event: any) => (_ctx.Download(oldP))
                }, _hoisted_7, 8, _hoisted_5),
                _createElementVNode("div", {
                  class: "TumiClose",
                  onClick: ($event: any) => (_ctx.DeleteOldPicture(oldP))
                }, "x", 8, _hoisted_8)
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_TransitionGroup, { name: "image" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newPictures, (newP) => {
              return (_openBlock(), _createElementBlock("div", {
                key: newP.name,
                class: "col-3 TumiPicture mt-3"
              }, [
                _createElementVNode("img", {
                  src: newP.file,
                  class: "img-fluid",
                  alt: newP.name
                }, null, 8, _hoisted_9),
                _createElementVNode("div", {
                  class: "TumiClose",
                  onClick: ($event: any) => (_ctx.DeleteNewPicture(newP.name))
                }, "x", 8, _hoisted_10)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("ul", null, [
        _createVNode(_TransitionGroup, { name: "image" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oldFiles, (oldF) => {
              return (_openBlock(), _createElementBlock("li", {
                key: oldF,
                class: "row align-items-center"
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(oldF), 1),
                _createElementVNode("div", _hoisted_12, [
                  oldF
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.Download(oldF))
                      }, _hoisted_15, 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: ($event: any) => (_ctx.DeleteOldFile(oldF))
                  }, "Delete", 8, _hoisted_17)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_TransitionGroup, { name: "image" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newFiles, (newF) => {
              return (_openBlock(), _createElementBlock("li", {
                key: newF,
                class: "row align-items-center"
              }, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(newF), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: ($event: any) => (_ctx.DeleteNewFile(newF))
                  }, "Delete", 8, _hoisted_20)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}